module.exports = __webpack_public_path__ + "media/sfx_swooshing.3de704c7.wav";